(() => {
  const STORAGE_KEY = 'mainRoseScrollRestore';

  const shouldSaveClick = (target) => {
    if (!target) return false;

    return target.closest(
      'a[href*="/products/"], a[href*="/collections/"], .product-card a, .main-rose-style-with__image-link, .mr-style-with-card__image-link'
    );
  };

  const saveScrollPosition = () => {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        url: window.location.href,
        scrollY: window.scrollY,
        timestamp: Date.now()
      })
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = shouldSaveClick(event.target);
      if (!link) return;

      saveScrollPosition();
    },
    true
  );

  window.addEventListener('beforeunload', () => {
    saveScrollPosition();
  });

  window.addEventListener('pageshow', () => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    let saved;

    try {
      saved = JSON.parse(raw);
    } catch {
      return;
    }

    if (!saved?.url || saved.url !== window.location.href) return;
    if (!saved.scrollY || Date.now() - saved.timestamp > 1000 * 60 * 30) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: saved.scrollY,
          behavior: 'instant'
        });
      });
    });
  });
})();